import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { share } from 'rxjs/operators';

@Injectable()
export class SpeedService {

    progress: number;
    progress$: Observable<any>;
    progressObserver: any;

    constructor() {
        this.progress$ = new Observable((observer) => {
            this.progressObserver = observer;
        }).pipe(share());
    }

    download(url: string): Observable<any> {
        return new Observable((observer) => {
            const xhr: XMLHttpRequest = new XMLHttpRequest();

            // for(let elt in xhr) {
            //   console.log('-elt = '+elt);
            // }

            xhr.onreadystatechange = () => {

                if (xhr.readyState === 4) {
                    // console.log(xhr.getResponseHeader("Content-Length"));
                    if (xhr.status === 200) {
                        //observer.next(JSON.parse(xhr.response));
                        observer.complete();
                    } else {
                        observer.error(xhr.response);
                    }
                }
            };

            xhr.onprogress = (event) => {
                // console.log('ondownload');
                // console.log(event);
                this.progress = event.loaded;
                this.progressObserver.next(this.progress);
            };

            xhr.open('GET', url, true);
            xhr.send();
        });
    }
}
